import { render, staticRenderFns } from "./OrderedResponse.vue?vue&type=template&id=057cfd4c&scoped=true&"
import script from "./OrderedResponse.vue?vue&type=script&lang=js&"
export * from "./OrderedResponse.vue?vue&type=script&lang=js&"
import style0 from "./OrderedResponse.vue?vue&type=style&index=0&id=057cfd4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057cfd4c",
  null
  
)

export default component.exports